import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const promoCodePageSlice = createSlice({
    name: "promoCodePageSlice",
    initialState,
    reducers: {
        setPromoCodePageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setPromoCodeCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setPromoCodeTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setPromoCodeTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetPromoCodePagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setPromoCodePageLimit,
    setPromoCodeCurrentPage,
    setPromoCodeTotalCount,
    setPromoCodeTotalPages,
    resetPromoCodePagination,
} = promoCodePageSlice.actions;

export default promoCodePageSlice.reducer;